if (!customElements.get('armor-clean-opening')) {
  customElements.define('armor-clean-opening', class extends HTMLElement {
    connectedCallback() {
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = 0;
      this.update = () => {
        this.frame = 0;
        const rect = this.getBoundingClientRect();
        const progress = this.motion.matches ? 0 : Math.max(0, Math.min(1, -rect.top / Math.max(rect.height, 1)));
        this.style.setProperty('--ac-progress', progress.toFixed(3));
      };
      this.queue = () => { if (!this.frame) this.frame = requestAnimationFrame(this.update); };
      this.events = new AbortController();
      const signal = this.events.signal;
      window.addEventListener('scroll', this.queue, {passive:true, signal});
      window.addEventListener('resize', this.queue, {passive:true, signal});
      this.motion.addEventListener('change', this.queue, {signal});
      this.update();
    }
    disconnectedCallback() { this.events?.abort(); cancelAnimationFrame(this.frame); }
  });
}

if (!customElements.get('armor-clean-buying')) {
  customElements.define('armor-clean-buying', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.querySelectorAll('[data-collection-variant-picker]').forEach((picker) => {
        let summary = picker.nextElementSibling;
        if (!summary?.classList.contains('ac-selection')) {
          summary = document.createElement('p');
          summary.className = 'ac-selection';
          summary.setAttribute('aria-hidden', 'true');
          picker.after(summary);
        }
        const update = () => { summary.textContent = picker.selectedOptions[0]?.textContent.trim() || ''; };
        picker.addEventListener('change', update, {signal:this.events.signal});
        update();
      });
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}
